import { getParams } from './helpers/params.js';
import { setCookie, getCookie } from './helpers/cookies.js';
import { isEmpty } from './helpers/is-empty.js';

( function() {
	let params = getParams(window.location.href);
	if (isEmpty(params)) return;
	console.log(params);

	for (let key in params) {
		if (!key.startsWith('utm_')) continue;
		console.log(key, params[key]);
		// localStorage.setItem(key, params[key]);
		setCookie(key, params[key], 30);
	}
} )();


